import Phaser from 'phaser';
import confetti from 'canvas-confetti';
 
export default class FinalEnd extends Phaser.Scene {
  private infoMessageBox!: Phaser.GameObjects.Rectangle;
  private infoText!: Phaser.GameObjects.Text;
  private infoHeader!: Phaser.GameObjects.Text;
  private okButton!: Phaser.GameObjects.Text;
  private isInfoVisible: boolean = false;
 
  constructor() {
    super('finalend');
  }
 
  create() {
    const bg = this.add.image(0, 0, 'rechenzentrum').setOrigin(0, 0);
    bg.setDisplaySize(this.scale.width, this.scale.height);
 
    confetti({
      particleCount: 400,
      spread: 180,
      startVelocity: 30,
      origin: { x: 0.5, y: 0 },
    });
 
    const fontSize = Math.min(this.scale.width, this.scale.height) / 18;
    const centerX = this.scale.width / 2;
    let currentY = this.scale.height / 2 - 100;
 
    this.add
      .text(centerX, currentY, 'Mission Accomplished!', {
        fontSize: `${fontSize}px`,
        fontStyle: 'bold',
      })
      .setOrigin(0.5);
    currentY += 70;
 
    const spielername = sessionStorage.getItem('player') || 'Anonym';
    const stoppedTimeRaw = sessionStorage.getItem('stoppedTime') || '0';
    const points = parseInt(sessionStorage.getItem('score') || '0', 10);
    const penaltySecondsPerPoint = 2;
 
    let baseSeconds = 0;
    if (stoppedTimeRaw.includes(':')) {
      const [minStr, secStr] = stoppedTimeRaw.split(':');
      const minutes = parseInt(minStr, 10) || 0;
      const seconds = parseInt(secStr, 10) || 0;
      baseSeconds = minutes * 60 + seconds;
    } else {
      baseSeconds = parseFloat(stoppedTimeRaw) || 0;
    }
 
    const penaltySeconds = points * penaltySecondsPerPoint;
    const totalSeconds = baseSeconds + penaltySeconds;
 
    // Score zur späteren Verwendung speichern
    sessionStorage.setItem('highscoreTime', totalSeconds.toString());
 
    const formatTime = (seconds: number) => {
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60);
      return `${m}:${s.toString().padStart(2, '0')}`;
    };
 
    this.add
      .text(centerX, currentY, `Herzlichen Glückwunsch, ${spielername}!`, {
        fontSize: `${fontSize * 0.8}px`,
        fontStyle: 'bold',
      })
      .setOrigin(0.5);
    currentY += 50;
 
    this.add
      .text(centerX, currentY, `Gesamtzeit: ${formatTime(totalSeconds)}`, {
        fontSize: `${fontSize * 0.8}px`,
        fontStyle: 'bold',
      })
      .setOrigin(0.5);
    currentY += 70;
 
    this.add
      .text(
        centerX,
        currentY,
        'Willkommen im Rechenzentrum von FakeBook!',
        { fontSize: `${fontSize * 0.8}px`, fontStyle: 'bold' }
      )
      .setOrigin(0.5);
 
    const buttonWidth = this.scale.width / 4.5;
    const buttonHeight = this.scale.height / 15;
    const padding = 20;
    const buttonXX = this.scale.width - padding - buttonWidth / 2;
    const buttonYY = this.scale.height - padding - buttonHeight / 2;
 
    const startButton = this.add
      .rectangle(buttonXX, buttonYY, buttonWidth, buttonHeight, 0x333333)
      .setInteractive()
      .setStrokeStyle(2, 0xffffff)
      .on('pointerover', () => startButton.setFillStyle(0x555555))
      .on('pointerout', () => startButton.setFillStyle(0x333333))
      .on('pointerdown', () => {
        const name = sessionStorage.getItem('player') || 'Anonym';
        const scoreStr = sessionStorage.getItem('highscoreTime') || '9999';
        const score = parseFloat(scoreStr);
 
        // Score senden → danach Szene wechseln
        submitScore(name, score, () => {
          this.scene.stop();
          this.scene.start('bestespieler');
        });
      });
 
    this.add
      .text(buttonXX, buttonYY, 'Spiel beenden', {
        fontSize: `${fontSize * 0.8}px`,
        color: '#ffffff',
      })
      .setOrigin(0.5);
 
    const infoButtonY = buttonYY;
    const infoButton = this.add
      .rectangle(centerX, infoButtonY, buttonWidth, buttonHeight, 0x333333)
      .setInteractive()
      .setStrokeStyle(2, 0xffffff)
      .on('pointerover', () => infoButton.setFillStyle(0x555555))
      .on('pointerout', () => infoButton.setFillStyle(0x333333))
      .on('pointerdown', () => this.toggleInfoMessage());
 
    this.add
      .text(centerX, infoButtonY, 'Weitere Infos', {
        fontSize: `${fontSize * 0.8}px`,
        color: '#ffffff',
      })
      .setOrigin(0.5);
  }
 
  private toggleInfoMessage(): void {
    if (this.isInfoVisible) {
      this.infoMessageBox.setVisible(false);
      this.infoHeader.setVisible(false);
      this.infoText.setVisible(false);
      this.okButton.setVisible(false);
      this.isInfoVisible = false;
    } else {
      this.createInfoMessage();
      this.isInfoVisible = true;
    }
  }
 
  private createInfoMessage(): void {
    const fontSize = Math.min(this.scale.width, this.scale.height) / 18;
 
    this.infoMessageBox = this.add
      .rectangle(this.scale.width / 2, this.scale.height / 2, 600, 300, 0xffffff)
      .setStrokeStyle(2, 0x000000)
      .setOrigin(0.5);
 
    this.infoHeader = this.add
      .text(
        this.scale.width / 2,
        this.scale.height / 2 - 100,
        'Was ist ein Rechenzentrum?',
        {
          fontSize: `${fontSize}px`,
          fontStyle: 'bold',
          color: '#000000',
          align: 'center',
        }
      )
      .setOrigin(0.5);
 
    this.infoText = this.add
      .text(
        this.scale.width / 2,
        this.scale.height / 2,
        '- Ein Gebäude, in dem viele Computer und Server arbeiten.\n' +
        '- Es speichert und verarbeitet große Mengen an Daten, z.B. von Webseiten oder Apps.\n' +
        '- Daten werden verschlüsselt, damit niemand Unbefugtes sie lesen kann.',
        {
          fontSize: `${fontSize * 0.6}px`,
          color: '#009900',
          align: 'center',
          wordWrap: { width: 550, useAdvancedWrap: true },
          lineSpacing: 8,
        }
      )
      .setOrigin(0.5);
 
    this.okButton = this.add
      .text(this.scale.width / 2, this.scale.height / 2 + 130, 'OK', {
        fontSize: `${fontSize}px`,
        fontStyle: 'bold',
        color: '#000000',
      })
      .setOrigin(0.5)
      .setInteractive()
      .on('pointerdown', () => this.toggleInfoMessage());
  }
}
 
// Hilfsfunktion zum Senden des Scores
function submitScore(name: string, score: number, callback: () => void) {
  const formData = new FormData();
  formData.append('game', 'social');
  formData.append('name', name);
  formData.append('score', score.toString());
 
  const xhr = new XMLHttpRequest();
  xhr.open('POST', './scores/update.php', true);
 
  xhr.onload = () => {
    console.log('Highscore-Upload OK', xhr.responseText);
    if (xhr.status === 200) callback();
  };
 
  xhr.onerror = () => {
    console.error('Upload fehlgeschlagen');
    callback(); // Optional: hier kannst du den callback weglassen, um bei Fehlern nicht weiterzugehen
  };
 
  xhr.send(formData);
}